import { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Set auth token
  const setAuthToken = (token) => {
    if (token) {
      api.defaults.headers.common.Authorization = `Bearer ${token}`;
      localStorage.setItem('token', token);
    } else {
      delete api.defaults.headers.Authorization;
      localStorage.removeItem('token');
    }
  };

  const updateUser = (userData) => {
    setUser(userData);
  };

  const needsProfileCompletion = user && 
    (user.age === "" || user.sex === "" || user.user_phone === "");

  // Load user
  const loadUser = async () => {
    try {
      setAuthToken(token);
      const res = await api.get('/auth/me');
      setUser(res.data.user);
      setIsAuthenticated(true);
    } catch (err) {
      //logout();
    } finally {
      setLoading(false);
    }
  };

  // Login user
  const login = async (token, userData) => {
    setToken(token);
    setAuthToken(token);
    setUser(userData);
    setIsAuthenticated(true);
    navigate('../');
  };

  // Logout user
  const logout = () => {
    setToken(null);
    setAuthToken(null);
    setUser(null);
    setIsAuthenticated(false);
    navigate('../');
  };

  // Check if token exists on app load
  useEffect(() => {
    if (token) {
      loadUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        isAuthenticated,
        loading,
        login,
        logout,
        loadUser,
        updateUser,
        needsProfileCompletion
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};